// Copyright (c) StrangeBee 2023

import React, { ReactElement, useEffect, useState } from 'react';
import { THInputProps } from '../THInput/THInput';
import { THInputNumber } from '../THInputNumber/THInputNumber';
import { THSelect } from '../THSelect/THSelect';
import { singularize } from '@Helpers/string';

import './THNumberSelect.scss';

interface THNumberSelectProps extends THInputProps {
    options: string[];
}

export const THNumberSelect = ({ value = '', onChange, options, min }: THNumberSelectProps): ReactElement => {
    const [number, label] = (value || '').toString().split(' ');

    const [numberValue, setNumberValue] = useState(number);
    const [labelValue, setLabelValue] = useState(label);

    const isNumberNull = numberValue === 'null';

    useEffect(() => {
        if (numberValue !== number || label !== labelValue) {
            const computeValue = isNumberNull ? undefined : `${numberValue} ${labelValue}`;
            onChange?.(computeValue as any);
        }
    }, [numberValue, labelValue, onChange]); //eslint-disable-line

    return (
        <div className="th-number-select">
            <THInputNumber
                className="th-number-select__number"
                value={isNumberNull ? undefined : numberValue}
                onChange={(value) => setNumberValue(value + '')}
                min={min}
            />
            <THSelect
                className="th-number-select__select"
                options={options.map((value) => ({
                    label: Number(numberValue) < 2 ? singularize(value) : value,
                    value,
                }))}
                value={labelValue}
                onChange={(value) => setLabelValue(value)}
                showSearch
            />
        </div>
    );
};
